import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'

import { sum } from 'lib/array/arrayUtils'
import type { IntlShape } from 'react-intl'
import type { Moment } from 'moment'
import moment from 'moment'

export function formatDate(date?: string | Moment, format: string = DMY_CASUAL_FORMAT) {
  return date ? moment(date).format(format) : undefined
}

export function getOccupancyDescription(
  occupancies: Array<App.Occupants>,
  intl: IntlShape,
  includeOccupancyCount: boolean = true,
): string {
  const hasChildren = occupancies.some(occ => occ.childrenAge?.length)
  const occupancyCount = sum(occupancies, occ => occ.adults + (occ.childrenAge?.length ?? 0))

  const guestLabel = hasChildren
    ? intl.formatMessage(
        {
          id: 'v4C1PepTLU',
          defaultMessage: '{count, plural, one {# guest} other {# guests}}',
          description: 'Guest count in occupancy description in the occupancy or guest picker',
        },
        { count: occupancyCount },
      )
    : intl.formatMessage(
        {
          id: 'F48IudAoId',
          defaultMessage: '{count, plural, one {# adult} other {# adults}}',
          description: 'Adult count in occupancy description in the occupancy or guest picker',
        },
        { count: occupancyCount },
      )

  if (!includeOccupancyCount) return guestLabel

  return intl.formatMessage(
    {
      id: 'vtw1jVVGNg',
      defaultMessage: '{guestLabel} ({unitCount, plural, one {# room} other {# rooms}})',
      description: 'Full occupancy description with guest count and room count, e.g. "2 guests (1 room)"',
    },
    {
      guestLabel,
      unitCount: occupancies.length,
    },
  )
}
